import { useContext, useState } from "react";
import { Layout } from "antd";
import classNames from "classnames";
import { isBrowser } from "react-device-detect";
import { Outlet } from "react-router-dom";

//import { getDataLocalStorage } from "../../../utils/helpers/localStorageHelper";
import DashboardHeader from "../../../components/DashboardHeader";
import DashboardSideBar from "../../../components/DashboardSideBar";
import ThemeContext from "../../../utils/context/Theme/ThemeContext";

import "./Dashboard.css";
import "./DarkDash.css";



const DashboardLayout = ({ ContentComponent }) => {
  const { Content } = Layout;

  const { themeMode } = useContext(ThemeContext);
  const [collapsed, setCollapsed] = useState(false);
  
  return (
    <Layout
      className={classNames("dashboard", {
        darkDash: themeMode === "dark",
      })}
    >
      <DashboardSideBar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
      />

      <Layout
        className={classNames({
          "main-layout collapsed": isBrowser && collapsed,
          "main-layout": isBrowser && !collapsed,
        })}
      >
        <DashboardHeader collapsed={collapsed} setCollapsed={setCollapsed} />
        <Content
          className={classNames("dashboard-content", {
            lightDashContent: themeMode === "light",
            darkDashContent: themeMode === "dark",
          })}
        >
          {ContentComponent}
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default DashboardLayout;
